
import { Link } from 'react-router-dom';
import Button from '../../../components/base/Button';

export default function Services() {
  const services = [
    {
      id: 1,
      title: 'リノベーション',
      description: '建物に新しい価値と機能を付加し、お客様のニーズに合わせた理想的な空間を創造します。',
      icon: 'ri-hammer-line',
      color: 'bg-blue-500',
      image: 'https://public.readdy.ai/ai/img_res/9ef314e324a63c7b7143c708cdd42813.jpg'
    },
    {
      id: 2,
      title: 'FM・メンテナンス',
      description: '建物の価値を維持し、快適で安全な環境を継続的に提供するための総合管理サービスです。',
      icon: 'ri-tools-line',
      color: 'bg-green-500',
      image: 'https://readdy.ai/api/search-image?query=Professional%20facility%20maintenance%20technician%20performing%20inspection%20of%20building%20systems%20in%20modern%20Japanese%20commercial%20building%20with%20advanced%20monitoring%20equipment%20and%20safety%20protocols&width=400&height=300&seq=service2&orientation=landscape'
    },
    {
      id: 3,
      title: 'コンサルティング',
      description: '建物に関する課題を専門的に分析し、最適なソリューションを提案する戦略的アドバイザリーサービスです。',
      icon: 'ri-lightbulb-line',
      color: 'bg-orange-500',
      image: 'https://readdy.ai/api/search-image?query=Professional%20business%20consultation%20meeting%20with%20facility%20management%20experts%20reviewing%20building%20plans%20and%20energy%20efficiency%20reports%20in%20modern%20conference%20room%20with%20collaborative%20planning%20atmosphere&width=400&height=300&seq=service3&orientation=landscape'
    }
  ];

  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            事業内容
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            建物の課題に、最適な答えを。３つの事業領域でお客様の大切な資産をサポートします。
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {services.map((service) => (
            <div key={service.id} className="bg-white rounded-xl shadow-lg hover:shadow-xl transition-shadow duration-300">
              <div className="relative overflow-hidden rounded-t-xl">
                <img 
                  src={service.image} 
                  alt={service.title}
                  className="w-full h-48 object-cover object-top"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent"></div>
                <div className={`absolute top-4 left-4 ${service.color} text-white p-3 rounded-lg`}>
                  <div className="w-6 h-6 flex items-center justify-center">
                    <i className={`${service.icon} text-xl`}></i>
                  </div>
                </div>
              </div>
              
              <div className="p-6">
                <h3 className="text-xl font-bold text-gray-900 mb-3">
                  {service.title}
                </h3>
                <p className="text-gray-600 mb-6 leading-relaxed">
                  {service.description}
                </p>
                <Link to="/services">
                  <Button variant="outline" className="w-full">
                    詳細を見る
                  </Button>
                </Link>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-12">
          <Link to="/services">
            <Button size="lg">
              すべての事業内容を見る
              <div className="w-5 h-5 flex items-center justify-center ml-2">
                <i className="ri-arrow-right-line"></i>
              </div>
            </Button>
          </Link>
        </div>
      </div>
    </section>
  );
}
